import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import { getDateFormat } from "./helpers";

const InformationColumn = ({
  lastReviewDate,
  nctIds,
  ascoEntry,
  variant,
  variantUrl,
}) => {
  return (
    <div>
      <small>
        {variant && (
          <div className="tw-mb-0">
            {variantUrl ? (
              <a target="_blank" href={getVarsoUrl(variantUrl)}>
                {variant}
              </a>
            ) : (
              variant
            )}
          </div>
        )}
        {lastReviewDate && (
          <div className="tw-mb-0">
            <p className="tw-mb-0">
              <strong>Last review:</strong>
            </p>
            {getDateFormat(lastReviewDate)}
          </div>
        )}
        {ascoEntry && (
          <div className="tw-mb-0">
            {ascoEntry.asco_citation_id && (
              <React.Fragment>
                <p className="tw-mb-0">
                  <strong>ASCO citation:</strong>
                </p>
                <a
                  href={getVarsoUrl(
                    `https://meetings.asco.org/abstracts-presentations/${ascoEntry.asco_citation_id}`
                  )}
                  target="_blank"
                >
                  {ascoEntry.asco_citation_id}{" "}
                </a>
              </React.Fragment>
            )}
            {ascoEntry.asco_abstract_id && (
              <React.Fragment>
                <p className="tw-mb-0">
                  <strong>ASCO abstract:</strong>
                </p>
                {ascoEntry.asco_abstract_id}
              </React.Fragment>
            )}
          </div>
        )}
        {nctIds && nctIds.length > 0 && (
          <div className="tw-mb-0">
            <p className="tw-mb-0">
              <strong>Clinical trials identifiers:</strong>
            </p>
            {nctIds.map((id, i) => {
              return (
                <div key={i} className="tw-mb-0">
                  <a
                    href={getVarsoUrl(
                      `https://clinicaltrials.gov/ct2/show/${id}`
                    )}
                    target="_blank"
                  >
                    {id}
                  </a>
                </div>
              );
            })}
          </div>
        )}
        {lastReviewDate === "" && isEmpty(ascoEntry) && isEmpty(nctIds) && (
          <div className="tw-mb-0">No data available</div>
        )}
      </small>
    </div>
  );
};

InformationColumn.propTypes = {
  lastReviewDate: PropTypes.string,
  nctIds: PropTypes.arrayOf(PropTypes.string),
  ascoEntry: PropTypes.shape({
    asco_citation_id: PropTypes.string,
    asco_abstract_id: PropTypes.string,
  }),
  variant: PropTypes.string,
  variantUrl: PropTypes.string,
};

InformationColumn.defaultProps = {
  lastReviewDate: "",
  nctIds: [],
  ascoEntry: {},
  variant: "",
  variantUrl: "",
};

export default InformationColumn;
